// Core
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Styles
import './styles.scss';
import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';

import banner from 'assets/images/about_banner.webp'
import Logo from 'assets/images/logo.png'
import ReactPlayer from 'react-player';

const About = () => {
    const { currentLang } = useSelector((store) => store.commonData);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [about, setAbout] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [para1, setPara1] = useState('')
    const [para2, setPara2] = useState('')

    const fetchAbout = async () => {
        setLoading(true)
        const res = await fetchData(restAPIs.getAbout(currentLang?.id));
        setAbout(res);
        const result = res?.description.split(/\n\n/);
        setPara1(result[0])
        setPara2(result[1])
        setLoading(false)
        
    }

    useEffect(() => {
        fetchAbout();
    }, [currentLang]);

    return (
        <>
            <div className='__about_banner'>
                <div className='player-wrapper __one'>
                    <ReactPlayer url={'https://vimeo.com/784597575/e78b61e833'} controls={false} playing={true}
                        className='react-player'
                        width='100%'
                        height='100%'
                        playsinline={true}
                        muted={false}
                        volume={0}
                    />
                </div>
            </div>
            <div className='container'>
                <div className='row justify-content-center' >
                    <div className='col-md-4 mb-3 mt-5'>
                        <h5 className='mb-3'>{about?.title}</h5>
                        <h3 className='mb-4'>{about?.overview}</h3>
                    </div>
                    <div className='col-md-4 mt-5 text-center'>
                        <img src={Logo} alt="" className='mb-5' height="100px" />
                        
                    </div>
                </div>
                <div className='row justify-content-center'>
                    <div className='col-md-4'>
                    <p style={{ textAlign: 'justify', lineHeight: 1.7 }} dangerouslySetInnerHTML={{ __html: para1 && para1 }}></p>
                    </div>
                    <div className='col-md-4'>
                    <p style={{ textAlign: 'justify', lineHeight: 1.7 }} dangerouslySetInnerHTML={{ __html: para2 && para2 }}></p>
                    </div>
                    
                </div>
            </div>
        </>
    );
};

export default About;
